define([
	"dojo/_base/declare",
	"dijit/form/ToggleButton",
	"./_Plugin",
	"dojo/text!./resources/Button.html",
], function (declare,ToggleButton,_Plugin,template) {

	return declare([ToggleButton, _Plugin], {
		templateString: template,

		/**
		 * Enable indentation if shape(s) are selected
		 * @param  {Shape[]} shapes
		 * @param  {Object} shapeAttrs
		 * @param  {Object} textAttrs
		 * @return {Boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			this.set("checked", false, false);
			if (shapes && shapes.length) {
				return this.inherited(arguments);
			} else {
				return false;
			}
		},

		/**
		 * Apply style
		 * @param  {Event} e
		 */
		onClick: function(e) {
            this.set("checked", false, false);
			this.editor.setTextStyle(this.indentValue, undefined, true);
		}
	});
});
